/** Relative age for live meter samples (sidebar backup label). */
export function formatSampleAge(tsMs: number | null, now = Date.now()): string {
  if (tsMs == null || !Number.isFinite(tsMs)) return "—";
  const s = (now - tsMs) / 1000;
  if (s < 0.15) return "now";
  if (s < 60) return `${s.toFixed(1)}s ago`;
  return formatTsMs(tsMs);
}

/** Format epoch ms as Europe/Amsterdam wall clock with millisecond suffix. */
export function formatTsMs(tsMs: number): string {
  if (!Number.isFinite(tsMs)) return "—";
  try {
    const str = new Date(tsMs).toLocaleString("de-DE", {
      timeZone: "Europe/Amsterdam",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const ms = (tsMs % 1000 + 1000) % 1000;
    const pad = ms < 10 ? "00" : ms < 100 ? "0" : "";
    return `${str}.${pad}${ms}`;
  } catch {
    return String(tsMs);
  }
}
